export const autoLabelDatabase = [
    {
        idCode: 'ea^P@@@LdbVRRbbvRRbLVRbrTVRdsRuMTmSSMLuSPEdEaLWEiATSUCRu]_QKPiHn{FkY]vLVZ{l[MuwXrX[ni`tw]cQen{FC[Mv\\\\wQuw]cSgf{v~[kXEnuhVzVQ{lX]bw\\qK]STmvLswXw[gnqfwxeXN@@AkhB\\@S@XM]@C`BXB`[hBL@C@DpG@wPDXAN@I`IFn`NpALAhMtAF@Q`BXBqkhAl@S@^C]@Q`BX@f@bZz@k@DpFPwPDXAf@I`Jan`@P@l@S@]C]@Q`@x@f@fFz@c@BpALAlMt@f@A`BXBx[h@D@s@DpGpwPDXAV@I`HQn`@PAL@S@Tc]@@`DX@f@eFz@c@NpALAjMtAF@M`BXB',
        coordinates: '!BmpJH@oy?mwvH_[\\Bb@Jw_Xa}mpK~_x`B?g~w_Xa}mpJH@k]}bGw~_{\\Bb@JH__x@b@JH_X`BbGw~@H`BbGvH@ha}?`BH@ha}b@K~@Ha}',
        mf: 'C40H56',
        mw: 536.88464,
        label: 'Lycopene',
    },
    {
        idCode: 'eaYP@@@LdbbTbsbrTVRTVRbrbbdWBaOKUMUMLtsSMLuUU@RTVdyAVUUCRu]_tJPknqjuW]cEfn{Fs]]vLfF{jXMMwXtY[nq`vs]gGMt]]wXtyyn}ofzvA[mZEnqdVzVq{lX\\RwTuO]c]f^{F[\\mwM~IVC`@@Zz@[@DpFCWPEX@f@hZz@{@DpGCWPDX@f@dZz@K@DpF`wPDX@N@I`KFn`ApALAxut@f@I`Han`HpCl@S@YC]@Q`CX@f@jZz@s@DpGSWPDx@f@fFz@c@@pALAlMtAF@S`BXBx[hBL@c@DpGpwPDX@f@I`HQn`HpCL@S@Xc]@Q`AX@f@iFz@S@@pALArMtAF@U`BXB',
        coordinates: '!B?`BH_[]}mpJH?H`BmpIt^pnGmwvH_X`B?g~H_X`BbGvH@oy?bGvH@ha}b@JH__x@b@JH_X`BbGw~@H`BbGw~_x`BbGvw_Xa}f~atnH`B',
        mf: 'C40H56',
        mw: 536.88464,
        label: 'beta-carotene',
    },
    {
        idCode: 'eghP@@@LddTTVdRVbLf|VRgEdbgfPRUUUUUUUUUUUW@B`RDhbb\\ST@~P`aBOt^PAnshFzNP{lXMawXtXcnqiuG]cEfF{vx[mXQnqiN{FSJ]vMft{lZlYw\\pZqnmgFzV|[jXKnqntW]cCdn{F[YMwLUwTtzkniasW]SAnnzfSC]uMFf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmwvH__x@?g~w@oy??g~H@k\\B?`@_YSF?bGvH_Xa}Gqhq`ELXb@KxF}MgYVBw?Cctm?vw?K_}m?s~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Cucurbitane',
    },
    {
        idCode: 'eghP@@@LddTbbtVdIVbdsRdabcfefSUUUUUUUUUUUW@D`bDh`bbbR@~PPbbOt^PAnchN{FKHMv]`w^qG]cCjN{FsL]vMVx{nXLIwXpZSnqhrc][Z]vMvL{lYMYwXsYqnuoF{FB{lZ]EwTpYInelfzfJ{jYMUwTtYinynnzfgC]uLNf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmpJH@oy??`C~@A}eL[~H__x@bGt_Fh`BTqc~_x`B?`AeXHa}bGvw?Cctb@KxF}Mgm?vw?K_}m?s~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Dammarane',
    },
    {
        idCode: 'eghP@@@LddTTVbTad|VLVR`fdea`VUUUUUUUUUUUUW@B`UBxRdBST@~P`bbOt^PCnq`tC]gHMvm`wXqG]cSjFzNX{lZMpwRpc][RMuLiwXq[Qn}cN{FSVMwLywTt{sniapW]cYhn{FkI]wLFr{l[lUwXpzknqfsW]SAnnzfSC]uMFf{j[LmwTq[[nijqw]S]knzf[@',
        coordinates: '!BmpK~_x`B?`Bw__x@bGvw_Xa}mpK~_{\\Bb@KxF}Mg?`@_YSF?Gqhq`ELXYVBw@cctm?vw@k_}mpK~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Lanostane',
    },
    {
        idCode: 'eghP@@@LddTbbtVdIVbdsRdabcfefSUUUUUUUUUUUW@B`RBhPbbbR@~PPbbOtnPAnchN{FKHMv]`w^qG]cCjN{FsL]vMVD{lXMIwXtYQnmmN{F{F]vLfl{lYlxwZwc]cA]vMNb{jXLdwRvS]SE]uLfj{jZLtw\\wW]SSanzfGS]uMfV{jXmmwTuX{ninuw]SM`',
        coordinates: '!BmpJH@oy??`C~@A}eL[~H__x@bGt_Fh`BTqc~_x`B?`AeXHa}bGvw@cctb@KxF}Mgm?vw@k_}mpK~_p',
        mf: 'C30H54',
        mw: 414.75876,
        label: 'Protostane',
    },
    {
        idCode: 'egdP@@@LddTQdVeRdtVLVRgD`bfag`VUUUUUUUUUUUUUp@jHICHy@du@OhCHQy@FzV`[mYAnylNzfgD]uLNh{lXLpwVwC]SBMv]HwXrg]cSmF{vL[hzsnqhsg]cEoN{FSA]vMfb{lZlew\\p[KnqnqW]cCjn{F[M]uLFz{jYLMwTtZ[nilrw]SEmnzfkG]uMvn{jYl',
        coordinates: '!BmpJH@o`[tv_~@K]}?`Bw@h`B?`Bw@k]}?`Bw@k\\B?`@_YSF?Gqhq`ELXYVBw@cctm?vw@k_}mpK~_p',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Cycloartane',
    },
    {
        idCode: 'egdP@@@LddTbbtVbtVtT|R`ebf`QVWVquUUUUUUUUUUTh@hHaJDIMHDhitidA}`aEDQQ~cr@]vMf`{lXlawXp{CnqdqG]SMjFzNX{lZmqwTwXSnqntg]cSeN{FcZMv\\Xw^ug]cMgNzfS^]uLNB{jXMEwXpYKnijvS][E]uMFj{nXLuwTt{inuaf{Ff[iY[nibvs]SGMwM]wTvX',
        coordinates: '!B?l]klaRrW`@TcVnM?l]kc_{XEHtTlo{GZ{IklalMZ{HTc_{GEHw~vAL|HgS~qqRrEHtAmqRMEKK~qp',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Friedelane',
    },
    {
        idCode: 'egdP@@@LddTbbtVadLTRltdabce`VSPvuUUUUUUUUUUUpAHHaAEhgIt`OdDHDc}Gd@{lXm@wQrG]cYlN{FkD]uMvh[lyan}nNzf[B]vLNd{lYLiwXs[Snq`qg]cQkFzv\\{l[mywXtxInuhf{FR{jZmewTrXkniauW]SAfnzfc]MtlLwTtw]sAenzfg[MwL]wTqZ{nilp',
        coordinates: '!BbGw~@K]}?g~H@oy??`Bw@h`BmpJH__x@bGvw_Yg@?g~H@ox@nuSOsURDotzH_Xa}bGwIPH`BuB^KAp',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Lupane',
    },
    {
        idCode: 'egdP@@@LddTbbtVdLJtRdvdabcedQPwVuUUUUUUUUUUUpAHHHmIELet`OhMHQy@FzN`{lXl`wYvC]{D]uLvh{l[LqwXu[cninpg]cAiN{FcJMumiwXpxsnqdug]cMgF{V|[lXKnijtW]c]dn{FgYMtlTwTuW]SIfnzfG]]uLFF[nZ[nibrw]SYmnzfcG]wLFn{jZ\\',
        coordinates: '!BmpJH@oy??`C~@K]}?g~H__x@bGvw@h`BmpK~_x`B?`Bw__x@bGvH_[\\BCwvw@h`BuB^KA?x@vuPlf@',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Oleanane',
    },
    {
        idCode: 'egdP@@@LddTbbtVadLTRvtdabce`UTpvuUUUUUUUUUUUHAHHaAIhgIyJet`OdDHDc}Gd@{lXm@wQrG]cYlN{FkD]uMvh[lyan}nNzf[B]vLNd{lYLiwXs[Snq`qg]cQkFzv\\{l[mywXtxInuhf{FR{jZmewTrXkniauW]SAfnzfg]MtlLwTtw]SQen{fC[MwL]wTqZ{nilp',
        coordinates: '!BRGw~`C]}?k}H@oz??`@w@d`BMpIH__z@RGtw__z@?k}H@ox@MpKwoS\\Bb@IH_Ta}?hC~@D`BANmSip',
        mf: 'C30H52',
        mw: 412.74288,
        label: 'Taraxastane',
    },
    {
        idCode: 'egdP@@@LdbTbbTVbbQvdjteB`e`QVSRvsUUUUUUUUUUTH`lIQAIH`hdidA}AaGzOHAwXvZCnqdrG]cElN{FGD]vMFh[hycnqjwG]S]aN{F{R]vMNT[l{Qn}cNzf[V]vLv\\{jYMywTpxKni`tW]SSdn{FCYMulUwTtZkny`sS]k]MvLMwTuZYneefzfv[nX{nibuw]SY`',
        coordinates: '!BR@K~os\\BRGuH_S]}?k|w__z@?k?~o?x@MpHw@o^}MpJH@da}RGw~`Ox@?k}H@ox@RGuH_T`BANmSip',
        mf: 'C30H50',
        mw: 410.727,
        label: 'Ursane',
    },
    {
        idCode: 'ek`P@@@LddTTVbvebQbrbbxtdlL\\BRjjjjjjjjjjk`APJaJQqYSj@_XPQQBd_i\\`G]cAhF{NP[m[AnqbN{FgTMt\\qwXt[anmaFzVd[jYSnqbvc]{F]vLfl[nYsnqlwg]cU`n{F{Q]vLNR{lYmewTpXkniduW]SQfnzfs]]uLVF{jZmMwTpy[ninvw]SMcnzfg@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw?Cctm?vw?K_}?`Bw?Oy?Stp',
        mf: 'C29H52',
        mw: 400.73187999999993,
        label: 'Poriferastane',
    },
    {
        idCode: 'ek`P@@@LddTTVbvebQbrbbxtdlL\\BRjjjjjjjjjjk`APJaJQqYSi@_XPQQBd_i\\`G]cAhF{NP[m[AnqbN{FgTMt\\qwXt[anmaFzVd[jYSnqbvc]{F]vLfl[nYsnqlwg]cU`n{F{Q]vLNR{lYmewTpXkniduW]SQfnzfs]]uLVF{jZmMwTpy[ninvw]SMcnzfg@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw?Cctm?vw?K_}?`Bw?Oy?Stp',
        mf: 'C29H52',
        mw: 400.73187999999993,
        label: 'Stigmastane',
    },
    {
        idCode: 'ekdPD@@@LLdTbRbRUTRtrTfVXTxDl\\RrZzvNjjjjjjjjjjjbHDPkET`Oz[IAwTrYCnifqG]SAjNzfsL]uMVx{lYlIwXwZSnihrg]SEmNzf{F]vMVl{l[LywXq[snqdpW]cChfzNR{lZMdwYqS]{U]vLFZ[k[inuaf{Ff{lZ\\lwRvs]SGMwL',
        coordinates: '!BgF_GS_ygnOiwSb|fnOeBRwiXe?U?IdIKnOfx~fSR?badSVSMYCK~YvQMYDw~YvPr?aadSVQMYCH',
        mf: 'C27H44O2',
        mw: 400.64435999999995,
        label: 'Spirostane',
    },
    {
        idCode: String.raw `fc@@@LddTTVbvebQbrbgMRlYpTuUUUUUUUUUW@JBheQrsNhGvHQREQ~atAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[Y{jXLWnidu^zfcM{j[Mwnibp~zfkS{jX\oninv~zf[@`,
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}?`Bw@oy?',
        mf: 'C28H50',
        mw: 386.705,
        label: 'Campestane',
    },
    {
        idCode: String.raw `fc@@@LddTTVbvebQbrbgMRlYpTuUUUUUUUUUW@JBheQrsNpGvHQREQ~atAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[Y{jXLWnidu^zfcM{j[Mwnibp~zfkS{jX\oninv~zf[@`,
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}?`Bw@oy?',
        mf: 'C28H50',
        mw: 386.705,
        label: 'Ergostane',
    },
    {
        idCode: 'ec`PH@@@LdTTRRTVVbfQdrvEG@g`USRvuUUUUUUUUUUXTKaEHC~frP]vLvP{jYMawXwXcnqjuG]SAfNzfs\\]vMfD{lXmIwTtYSnibvg]cIcN{FGVMt\\ywTu[snqhpS]gQMwlewTw[KnifqW]cAjfzvZ[m[inqan{FgSMtllwTvs]s@',
        coordinates: '!BtJW~hNpx{D_Pfd_ltJWPfak`esvhPox@jCvWPj`}jDK~gy\\}?bBhOZ`}?i~hPoz`jCvhOZaB',
        mf: 'C27H46O',
        mw: 386.66124,
        label: 'Furostane',
    },
    {
        idCode: 'eglPD@@@MlbbbbbRRqfbbbRRsDbeagaSPqrusP@PAE@D@HPP@@_tTQsnq`vS]KUMvltwYwS]cCMwMLwQrs][GMuM\\w^wxiXN@AAkhB\\@S@TC]@S`BXCFxXFz@G@DpFMpHMt@V@I`L[aQkhBL@S@VK]@Q`@X@f@qnGFn`ApALADut@V@I`Lan`Hp@L@S@UM]@I`BXCikhBl@S@SM]@]`BXCYkhCL@S@_M]@M`BXBEkh@l@c\\Hc]@Q`@XAFxIZz@g@Hw@kWP@xAFx@',
        coordinates: '!B?`Bw@h`B?`Bw__x@bOvw?H`BmpJH@h`Bm?w~@Hc}mpJH@ox@m?w~@Hc}b@Jw@k\\Bb@JH@ox@m?vH?P',
        mf: 'C28H18O2',
        mw: 386.44892,
        label: 'Bisanthrone',
    },
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjjh@Oz[PCFCPirJmbcDXtzdNXqhwIlJKRdrfLVu]cLYMZsNXv[sFkAXwZKFGIXs[JfCETrZjfcMTv[jfKCTuZZf{KTsX',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLxi]BWP`QLesvWPi\\}?i~WP`',
        mf: 'C27H48',
        mw: 372.67812,
        label: 'cholesterol',
    },
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjji`EATRhyY`OlPbdJc}MhCnq`tF{NPwZvF{FIwXtzc]GL{lZMqnmaMtmInie]vLVtw^qn{FSV[nYw]cYo]vMVCwXwZO]cCd}vLvswTpXo]SIj}uMF[wTv[o]SEa}uMVgwTwY_]SM`',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@k]}mpK~_p',
        mf: 'C27H48',
        mw: 372.67812,
        label: 'Cholestane',
    },
    {
        idCode: 'fa{@@@LddTTVbvebQbwMRlYpTuUUUUUUUUL@hJbUGKLA}bDTaT_hM@]vLF`wYrF{VpwXqN{FgT[hyg]cQnMulIneiMuLknqbvf{vMwXrZs]sN{l[M{nqjp^{F{Q{lX\\gnqfv^zfCE{jYMWnihs^zfs]{jXl',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYVBw@cctmwvw@`',
        mf: 'C24H42',
        mw: 330.59748,
        label: 'Cholane',
    },
    {
        idCode: 'fj}@p@@FmxI\\dTTTRbTRR~XJSdyhJHBb`JCBDqB`OlHadBc}AHAnqdMuLQncfMwMqnuaMtmIn}gMum~HdG@@awP@xAFxX{h@l@c\\J]tAF@I`Jnz@[@DpGW]@I`BXCGn`JpALASwPFX@f@y{h@l@S@P',
        coordinates: '!BbOvw?_y?bOrw?Oy?bGvw_Xc}m?w~@K]}?g~H@oy?bOrw?K\\B?`Bw@`',
        mf: 'C15H14O6',
        mw: 290.27016000000003,
        label: 'Flavan-3,4-diol',
    },
    {
        idCode: 'fjc@@@LddTTVbvebQyjUcNBfjjjjjjjj`EATRhy@~qBJPjOtj`N{FCP[lyC]kX[lXg]cSjMt\\snqhwFzvDwRtfzfUwXq[S]{F{lYMYnyg]vMf}wXuXO]c]h}vLNSwXs[O]SAb}uMF@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELXYV@x}@',
        mf: 'C21H36',
        mw: 288.51684,
        label: 'Pregnane',
    },
    {
        idCode: 'fj}@p@@LDhI\\bbbbbfqbRvxKUdyZBhb@`JAFEq@~QbNQ~`d`wRvF{fhwZwFzfDwXtfzNtwVuf{vDRC`@H{h@l@c\\B]t@N@QnAnz@c@DpEw]@M`BXC{n`DpALAcwPEX@f@i{hCL@S@\\}t@V@I`H',
        coordinates: '!B?`BH@k\\B?`BH_[]}?`Bw?Hc|?g~H@k_|bOvw?_x@bOrw?K\\B?`Bw@`',
        mf: 'C15H12O6',
        mw: 288.25428,
        label: 'Dihydroflavonol',
    },
    {
        idCode: 'fj}@p@@DEiI\\bbbfbTtQRQXHwhyZdJH@BJ@@OzBRC]KH[nZc]S\\[mXS]cJ[hxs][^[o[|QHN@Acn`BpBMpYwP@xAFxR{hBL@S@[]t@v@I`Knz@S@DpDO]@U`BXCGn`LpALAswPAX@f@`',
        coordinates: '!B?`Bw@h`Bmww~@Ox@bGvH?K_|bOs~_x`Bm?w~@Hc}m?rw@hc|?`Bw@`',
        mf: 'C15H10O6',
        mw: 286.23839999999996,
        label: 'Flavonol',
    },
    {
        idCode: 'fbmAP@@Fm{NRJJJIQJYIy`iNbf`h`JHB`PaLPOdHad_hI@MvLanibMt\\qnynMvlIneiMwlynmoqD`x@DNz@G@HwCG]@E`D[aSn`HpALAUwPCX@f@z{hAL@S@P}tAV@I`L^z@s@DpEO]@E`BXB',
        coordinates: '!BbOvw?_y?bOrw?Oy?bGvw_Xc}m?w~@K]}?g~H@hc|m?rw@ox@mpH',
        mf: 'C15H14O5',
        mw: 274.27116,
        label: 'Flavan-3-ol',
    },
    {
        idCode: 'fbmAP@@\\e{NQQQJJKFIKYgEFbehJH`HB``q@~`rOtDdFzVpw\\uF{VXwTwF{FDwQrfzvLw^wxbP\\@AG]@E`D[`Sn`ApBMpuwPDX@f@v{hAl@S@W]t@f@I`H^z@k@DpFO]@Y`BXBgn`BpALA@',
        coordinates: '!B?`BH@k\\B?`BH?_x@m?rH?Oy?b@Jw?Hc}m?w~@Hc|m?rw@ox@mpH',
        mf: 'C15H12O5',
        mw: 272.25527999999997,
        label: 'Flavanone',
    },
    {
        idCode: 'fbmAPD@\\}GHIrQQQQQHiQItDXKd`PP@ADP@@_tD`F{F`wTvF{fXwQpfzVtwZqf{vBwVwxbP\\@AG]@C`D[`Sn`HpALAiwPAXAFxR{hAl@S@U]t@f@I`Mnz@k@DpEw]@Y`BXBgn`BpALA@',
        coordinates: '!Bm?vH?_y?m?s~_xc|mwvH_[_}?`BH_Xc}m?rw@oy?b@JH?Ox@mpH',
        mf: 'C15H11O5',
        mw: 271.24734,
        label: 'Anthocyanidine',
    },
    {
        idCode: 'fbmAP@@\\e{NQQQJJKFIKYgEFbehFH`HB`@C~`d`wRvF{fhwZsFzfxwXpfzNTwVqf{vDRC`@H{h@l@c\\B]t@N@QnFnz@c@DpFw]@M`BXB{n`DpALACwPEX@f@q{hCL@S@T}t@V@I`H',
        coordinates: '!B?`BH@k\\B?`BH?_x@mpJH@oy?b@Jw@hc}m?w~@H`BmpJw@ox@mpH',
        mf: 'C15H10O5',
        mw: 270.2394,
        label: 'Flavone',
    },
    {
        idCode: String.raw `fluhP@DTxIPCQSdTRbbUTRRSNRT{sUKMUUUP@_t\dIlbcXjqIMR{LbwKMJGJivfMrlinSdmr|ynPVmr@`,
        coordinates: '!B?oum~QKy?ouBuo{}Dog]aYkMPlg~_ySz^bTT~Rc~?cK~eQKz',
        mf: 'C10H13N5O4',
        mw: 267.24422,
        label: 'deoxyguanosine',
    },
    {
        idCode: 'fbm@`@@HRY[UfUWISrXyZjj@@@H@@iIHMv]ancfMwlInqeMuminigMvmynydmtm~LdG@@IwPDx@f@t{h@\\@S@^]tAv@I`Lnz@c@DpDw]@M`BXC[n`DpALACwPEX@f@q{hCL@S@\\}t@V@I`H',
        coordinates: '!BFfASFF@ZKAc~@Hc}b@K~_xc}m?vH?_y?b@K~_?y?bOvH?Xc}b@H',
        mf: 'C18H18O2',
        mw: 266.33892,
        label: 'Butyrolactone',
    },
    {
        idCode: 'fb}@`@@FrQQJIIIHsIDiHvgIsUPTE@@T@@_tddF{vpwXqFzNXwVwFzfDwYrf{Vtw\\sfzVFRC`@H{hB\\@S@Z]t@N@I`Lnz@{@DpFw]@Q`BXC{n`FpALACwPBX@f@q{hBl@S@T}tAf@I`N^z@K@DpD',
        coordinates: String.raw `!Bb@J{UHc}f\CRtOy?b@KRtIg@bOvH?[mTs}JH@f]SLXCOtl?RLX@`,
        mf: 'C18H18O2',
        mw: 266.33892,
        label: 'Furanofuran lignan',
    },
    {
        idCode: 'fb}@`@@HRY[efuWHrRoIcejjh@@@h@@iIHMv]ancjMwlInqcMumYni`mvmEnylmtm~LdG@@IwPDx@f@l{h@\\@S@^]t@v@I`Lnz@{@DpEW]@Q`BXCkn`JpALA]wPBX@f@~{h@l@S@T}tAf@I`H',
        coordinates: '!BFfASFF@ZKAbH?_x@b@K~_x`B?`BH?[_}bOvH@h`B?g?~_xc}bOt',
        mf: 'C18H16O2',
        mw: 264.32304,
        label: 'Arylnaphthalene lactone',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjj@C~fT@q`tJ\\bkXhqFMNiCfLZMr[BbtiLicEmWXsFSVlsfMf|qjpVMvbqarVLv@',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLx',
        mf: 'C19H32',
        mw: 260.46308,
        label: 'steroid',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjjhAPUDjNPOlPbdJc}LhCnq`tF{NPwZvF{FIwXtzc]GL{lZMqnmaMtmInie]vLVtw^qn{FSV[nYw]cYo]vMVCwXwZO]cCd}vLv@',
        coordinates: '!BmpK~_x`B?`Bw__x@mwvH_Xa}mpK~_{\\Bb@K~@A}eGqhq`ELX',
        mf: 'C19H32',
        mw: 260.46308,
        label: 'Androstane',
    },
    {
        idCode: 'fle@P@@\\\\eIfVWyWyZCEhFB@`H@Pi_tddF{NpwQsF{vTwXqfzvlwTwf{VBw\\tVzVEbC`@H{hBL@S@R]t@f@I`MNz@[@DpDW]@Y`BXCKn`JpALAuwPAX@f@`',
        coordinates: '!B?`BH@k\\BbGw~@Ox@?g~H@hc|m?s~@K_}?`BH?K_|mpK~@K\\B',
        mf: 'C15H12O4',
        mw: 256.25628,
        label: 'Chalcone',
    },
    {
        idCode: 'fluA@@@ISLrrn~QchaSUTDD@A@@G}IHan}jMvLqnceMuminicMv]ynu`mwLeneoqd`x@DNz@{@DpGG]@Q`BXBSn`ApALAywPCX@f@b{hAL@S@Y]tAN@I`Mnz@k@DpEw]@Y`BXCGn`BpALA@',
        coordinates: '!BsA_LZNU_HNkeHBCeEOm?VVcSEOa?IfcLyU?eW~T`yRA?VW|f',
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 7-O-7′',
    },
    {
        idCode: 'fluA@@@ISKJn}jRfkQSUPTD@A@@G}IIAn}lMvLQncfMumqniaMv\\inumMwMYneoqd`x@BNz@g@DpFg]@C`BXCKn`NpALAMwPDX@f@n{hAl@S@_]t@f@I`H^z@k@DpFO]@Y`BXBgn`BpALA@',
        coordinates: String.raw `!BG@\\^LE?lEjpIY\]fOwhw^cBp^?A{~c]fOw~{~cBzMwhw^cB`,
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 7-O-9′',
    },
    {
        idCode: 'fluA@@@IRjkLjo`chaSUUP@@A@@G}IHansbMt\\qn}aMvMinmcMuMynu`mwLeneoqd`x@DNz@g@DpGG]@C`BXCSn`NpALAywPDX@f@r{hAl@S@U]t@f@I`Mnz@k@DpEw]@Y`BXCGn`BpALA@',
        coordinates: '!BKA`lYvAeXAjH@ha}bGw~_?y?b@Jw_Xa}bGvH__y??g~H@ha}',
        mf: 'C18H20O',
        mw: 252.35579999999996,
        label: 'Monofuranic lignan 9-O-9′',
    },
    {
        idCode: 'fdei`@LZlFHIJrQQQSIQEYDhZw`uUUPHEP@G}GIAc\\dI[ebgDTwJcfyLZwKdVECmVXuVm]gR[tvCQ`',
        coordinates: '!Bj?dT~_x@^bTEI_xrO]ZZtozUDoim~_{|i]Im~fwz?os~?@',
        mf: 'C10H13N5O3',
        mw: 251.24521999999996,
        label: 'deoxyadenosine',
    },
    {
        idCode: 'fdu@@@LddTRtjTrSA\\dZpXuUUUUUUT@hJddmHGqHQRIQjOtR`N{FsP{lXlcnqdvN{F{D{lX]Qncf]vMVywXtXW]cMiMv\\in}m]vLFLwVuf{V\\wXwfzVBwTtV{f@',
        coordinates: '!B?g~H?A|ZLPBH_Q}ebOuSYx`B?g~H_Xc}?g~H@hc}bGvH?@',
        mf: 'C18H30',
        mw: 246.43619999999999,
        label: 'Estrane',
    },
    {
        idCode: 'fhiQP@DX@IW`yEEDeDdbdsakMUMMUU@ASRPdrJMbsDfuFMrYEnUZRfyFRwJsfyNZwH',
        coordinates: '!B@yhCi_xl@yk~_pNZ?brT~ghe?bpCfaSyJO{~LozUDoh',
        mf: 'C10H14N2O5',
        mw: 242.23016,
        label: 'deoxythymidine',
    },
    {
        idCode: 'fdy@@@DjU^{yVg@qBBJj@@@@iIAMt\\in}mMv\\YnqkMulynioMvlEnyhmtm~LdG@@AwPDX@f@p{hAl@S@T]t@f@I`NNz@{@DpDg]@U`BXCSn`LpALAYwP@x@f@|{h@l@S@Y]tAN@I`H',
        coordinates: String.raw `!B?g~H@k\BbOvH?[_}b@K~_{\BbOvw?_y?m?vH?_y??g~H?P`,
        mf: 'C18H22',
        mw: 238.37267999999997,
        label: 'Dibenzylbutane',
    },
    {
        idCode: 'fde@@@LdbbTRtVRKIBTFHQEDE@D@ARRX[o[c]cB[h{S][F[jZs]g^[mXK]sQ[i[|YHN@@Cn`FpALAawPDX@f@h{hBl@S@R]t@f@I`MNz@{@DpEg]@E`BXCKn`LpALAUwP@x@f@n{hB\\@S@P',
        coordinates: '!B?`BH?[_}b@Jw@h`B?g~w@hc}m?vw?Xc}GvT_Foy??g~H?P',
        mf: 'C18H20',
        mw: 236.35679999999996,
        label: 'Arylnaphthalene',
    },
    {
        idCode: 'fde@@@LdbbbTRVQpcZ][t@DDDUA@ARR@[kYC]cX[mYc]S\\[oXS]KF[nZs]GA[l{|YHN@ACn`DpALAIwPDX@f@t{hCL@S@Y]t@v@I`Jnz@{@DpGW]@E`BXB{n`JpALA}wP@x@f@q{hB\\@S@P',
        coordinates: '!B?g~[iBAzfyl`AWh`_?yzHGi__?yzWrAzfyl`AYndKwHoCP',
        mf: 'C18H20',
        mw: 236.35679999999996,
        label: 'Dibenzocycloctane',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjj`@iE@TzCFCHavFMFIUjTYcFK\\npfLfeMeQ[TfLqlufMV]YoL[lEcM`',
        coordinates: '!BbOvw?_x@?g~H@k\\B?g~w@k_}bOvH?_x@GvVH@a|ZTq`',
        mf: 'C17H28',
        mw: 232.40931999999998,
        label: 'steroid core',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjjj@TDaLadCz`HaBHYAhRJ@[lzG]cAdMt]cnqhqF{VhwXsN{FK\\[oXW]cIiMulinemMuL[nqlun{FkN[n[w]c]`}vLv@',
        coordinates: '!BbGvw__x@?g~H@k\\B?g~w?K_}bOvH__x@GvVH?A|ZTq`',
        mf: 'C17H28',
        mw: 232.40931999999998,
        label: 'Gonane',
    },
    {
        idCode: 'f`qQP@DX@ISoILrl{jsfcMUMMUT@G}MIBSHhvKLR[TXwIdVyUiJ[eiK\\cN[eYk\\`',
        coordinates: '!B@yhCi_xl@yk~_pNZ?brT~ghe?bpT~Rc~?cK~eQKz',
        mf: 'C9H12N2O5',
        mw: 228.20328,
        label: 'deoxyuridine',
    },
    {
        idCode: 'f`qpP@DXxBSoYEDhihTdjBtYijjji`@iiHRYEfqQbQZdvXqnPjliS\\mI[dYs\\kM[d',
        coordinates: '!B@yk~K@Ne@yhCfoy??bpCiYSz^bTT~Rc~?cK~eQKz',
        mf: 'C9H13N3O4',
        mw: 227.21921999999998,
        label: 'deoxycytidine',
    },
    {
        idCode: 'fhy@`@@BrJJJJIPy[`eV|EhJ`@@`@C~`d`wRvF{fhwZwFzfDwXtfzNTwVuf{vDRC`@H{h@l@c\\B]t@N@QnCNz@c@DpGW]@M`BXB[n`DpALA]wPEX@f@~{hCL@S@P}t@V@I`H',
        coordinates: '!B?`BH@k\\B?`BH_[]}?`Bw@h`Bb@K~_{\\BbGvw_[]}mpH',
        mf: 'C15H12O2',
        mw: 224.25827999999998,
        label: 'Isoflavanone',
    },
    {
        idCode: 'fhy@`@@JRYfYU_XhwgAZd@`@H@@hIHMtlanyjMuMqnueMvMinccMumyn}oqD`x@FNz@K@Hw@g]@Q`BXBsn`ApBMpEwPCX@f@r{hAL@S@[]tAV@I`Knz@s@DpDO]@E`BXB',
        coordinates: '!B?`Bw@h`Bm?w~@Ox@bOw~_{\\Bb@JH@h`Bm?vw?Xc}mpH',
        mf: 'C15H10O2',
        mw: 222.24239999999998,
        label: 'Isoflavone',
    },
    {
        idCode: 'f`i@`@@VRYfYU]`eNMyh@`AB@@OzJRC]gT[l[c]GB{lXMIneeMuMinucMwlynyoMum~ILE@@QkhgBM|ZzApc\\fn`lHwX[hc@LHw@',
        coordinates: '!B?g~w_Xa}?g~w@oy?b@JH_[]}mwvH_Xa}?g~w@h`B',
        mf: 'C14H8O2',
        mw: 208.21552,
        label: 'Anthraquinone',
    },
    {
        idCode: 'foQ@`@@BRYfYWvBUXsf`B@@`@C~bd`wYuF{FxwQpn{FCR[iYS]SZ[mXs]{V[nYs][_bSAP@DZzIpc_Fn`\\HwIkhKBMvFzHpCBMp',
        coordinates: '!B?g~w?Xc}?g~w@oy?b@JH?[_}m?vH?Xc}mpJH@`',
        mf: 'C13H8O2',
        mw: 196.20452,
        label: 'Xanthone',
    },
    {
        idCode: String.raw `foQA@@@YEEEEDdbrRkF\t@D@D@@_tTdF{NhwXwFzNDwRtn{FCJ[j[S]kF[oZs]sN[k[|RXJ@@cWQND[xutCaFyM]AXQnpwQF@XQn`,
        coordinates: '!B?g~w?Xc}?g~w@oy?b@Jw?Xc}m?vH?Xc}mpJH@`',
        mf: 'C14H10O',
        mw: 194.23239999999998,
        label: 'Anthrone',
    },
    {
        idCode: 'dg|@@DjU_eZx{BAH@@BJozL`mvMK][JwTvmvl[]sVwRwxb`x@@]tAF@I`L]t@v@I`J]t@f@I`N]t@f@Y`I]tAV@I`M]tAf@I`K]tAF@Y`O]t@V@I`H',
        coordinates: '!B?`Bw?Xc}mpJw?Hc|m?vH?_y?bOrH?Xc}b@H',
        mf: 'C14H12',
        mw: 180.24928,
        label: 'Stilbene',
    },
    {
        idCode: 'fgA@@@DjYU_VByHu`@@@@@@OzJQC]gX[lXg]cAjMtmqniiMwLincmMvlYn}kMum~ILE@@AkhgBMxZzBpc]fn`\\HwD[hc@LHw@',
        coordinates: String.raw `!B?g~H@k\BbOvw?Xc}m?vH@k\Bb@JH?Xc}b@H`,
        mf: 'C14H10',
        mw: 178.2334,
        label: 'Anthracene',
    },
    {
        idCode: 'dclD@@UIfV][iuhFAH@OzBdMtmc]sTwZsMuMs]cBwQtmumk]{_bbB`@IwPVD[ewPND[`',
        coordinates: '!B?`BH@k\\B?`BH?_x@mpJH@h`B?`BH?P',
        mf: 'C10H6O2',
        mw: 158.15563999999998,
        label: 'Naphtoquinone',
    },
    {
        idCode: 'dmLD@@QIe[VfeVi@B@C~`iC]SHwXvMwMS]K\\wQpmvmK]{JwVp',
        coordinates: '!Bb@JH?_x@b@JH@ox@bOvH@h`BbOt',
        mf: 'C9H6O2',
        mw: 146.14463999999998,
        label: 'Coumarin',
    },
    {
        idCode: 'dazH`Jx@aJ]nji`dG}JPGJQap|T\\MGGBaIppP',
        coordinates: '!B?g~H@k_}?g~H?[_}?g|',
        mf: 'C5H11NOS',
        mw: 133.21434,
        label: 'methionine',
    },
    {
        idCode: 'detH@@rQQJHtpsPT@`APTAnqd[jXfzNinyf[i[f{VEn}i[k[|TPT@BNzApc_NzBpc\\',
        coordinates: '!BbOvw?_y?b@K~_{_}bOvH?X`B',
        mf: 'C9H8O',
        mw: 132.16152,
        label: '2H-Chromene',
    },
    {
        idCode: 'daDD@@qJYnnjjh@htQcIkESUKM[]s@',
        coordinates: '!Bm?vH?[_|?g?~_x`BbOt',
        mf: 'C6H12O2',
        mw: 116.15928000000001,
        label: 'pyranose',
    },
    {
        idCode: 'gOp`AdifMjj`OzVIcJVMM^Yzp',
        coordinates: '!BTv]`YW?~KF_~_q`l',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'furanose',
    },
    {
        idCode: 'gOp`Adigkjj`OzVIcKVMMYY|p',
        coordinates: '!Bm?vH?[_|?g?~_xc}',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'pyranose core',
    },
    {
        idCode: 'gFp`AdidvjhC~abXrecSWf@',
        coordinates: '!BTv]`YW?~KF_~_p',
        mf: 'C4H8O2',
        mw: 88.10552,
        label: 'furanose core',
    },
];
//# sourceMappingURL=autoLabelDatabase.js.map